module.exports = __webpack_public_path__ + "img/logo_pracavpresove.fd02a92.svg";